import { combineReducers } from 'redux';

import * as TS from '../../types';

import { communication } from './communication';
import { data } from './data';
import { edit } from './edit';

export const reducer = combineReducers<TS.ReduxState>({ communication, data, edit });
